import t, { useRef as b, Children as x, useState as f } from "react";
import v from "classnames";
import D from "react-magic-slider-dots";
import "react-magic-slider-dots/dist/magic-dots.css";
import { Slider as S } from "../Slider/Slider.js";
import a from "./dottedSlider.module.scss.js";
function h({
  sliderRef: e,
  type: r,
  active: o
}) {
  function s() {
    var c, n;
    switch (r) {
      case "left":
        (c = e == null ? void 0 : e.current) == null || c.slickPrev();
        break;
      case "right":
        (n = e == null ? void 0 : e.current) == null || n.slickNext();
        break;
    }
  }
  return /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      "aria-label": r,
      disabled: !o,
      className: v({
        [a.dottedArrow]: !0,
        [a.dottedArrow__right]: r === "right",
        [a.dottedArrow__left]: r === "left"
      }),
      onClick: () => s()
    }
  );
}
const M = t.forwardRef((e, r) => {
  const {
    settings: o,
    className: s,
    children: c,
    maxDots: n = 5,
    accentColor: A,
    showArrows: w,
    beforeChange: i,
    arrowBackgroundColor: g,
    arrowTextColor: p
  } = e, l = r ?? b(null), C = x.count(c), [k, E] = f(!!(o != null && o.infinite)), [N, _] = f(!0), m = {
    arrows: !1,
    ...o,
    className: "",
    dots: !0,
    // eslint-disable-next-line react/no-unstable-nested-components
    appendDots: (d) => /* @__PURE__ */ t.createElement("div", null, /* @__PURE__ */ t.createElement("div", { className: a.dottedSlider__controls }, w && /* @__PURE__ */ t.createElement(h, { active: k, sliderRef: l, type: "left" }), /* @__PURE__ */ t.createElement(D, { dots: d, numDotsToShow: n, dotWidth: 30 }), w && /* @__PURE__ */ t.createElement(h, { active: N, sliderRef: l, type: "right" }))),
    beforeChange(d, u) {
      _(u !== C - 1 || !!m.infinite), E(u !== 0 || !!m.infinite), i == null || i(d, u);
    }
  };
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      "data-testid": "dotted-slider",
      className: v(a.dottedSlider, s),
      style: {
        "--accentColor": A ?? "#EA565C",
        "--arrowBackgroundColor": g ?? "#FFF",
        "--arrowTextColor": p ?? "black"
      }
    },
    /* @__PURE__ */ t.createElement(
      S,
      {
        ref: l,
        settings: {
          ...m
        }
      },
      c
    )
  );
});
export {
  M as DottedSlider
};
//# sourceMappingURL=DottedSlider.js.map
